import { type ENV } from '@adv-frontend/yastore-modules/types';
import { type ThemeColor } from '../themekit';

type LogoUrls = Record<ENV | 'productionPublic', string>;
type ThemeLogoUrls = Record<ThemeColor, LogoUrls>;

const kitThemeLogoUrls: ThemeLogoUrls = {
    dark: {
        development: 'https://yastatic.net/s3/yastore-static/resources/images/yakit_logo_desktop_dev_dark.svg',
        prestable: 'https://yastatic.net/s3/yastore-static/resources/images/yakit_logo_desktop_test_dark.svg',
        production: 'https://yastatic.net/s3/yastore-static/resources/images/yakit_logo_desktop_prod_dark.svg',
        productionPublic: 'https://yastatic.net/s3/yastore-static/resources/images/yakit_logo_desktop_dark.svg',
    },
    light: {
        development: 'https://yastatic.net/s3/yastore-static/resources/images/yakit_logo_desktop_dev.svg',
        prestable: 'https://yastatic.net/s3/yastore-static/resources/images/yakit_logo_desktop_test.svg',
        production: 'https://yastatic.net/s3/yastore-static/resources/images/yakit_logo_desktop_prod.svg',
        productionPublic: 'https://yastatic.net/s3/yastore-static/resources/images/yakit_logo_desktop.svg',
    },
};

const ycpThemeLogoUrls: ThemeLogoUrls = {
    dark: {
        development: 'https://yastatic.net/s3/yastore-static/resources/images/yakit_ycp_logo_desktop_dev_dark.svg?v=2',
        prestable: 'https://yastatic.net/s3/yastore-static/resources/images/yakit_ycp_logo_desktop_test_dark.svg?v=2',
        production: 'https://yastatic.net/s3/yastore-static/resources/images/yakit_ycp_logo_desktop_prod_dark.svg?v=2',
        productionPublic: 'https://yastatic.net/s3/yastore-static/resources/images/yakit_ycp_logo_desktop_dark.svg?v=2',
    },
    light: {
        development: 'https://yastatic.net/s3/yastore-static/resources/images/yakit_ycp_logo_desktop_dev.svg?v=2',
        prestable: 'https://yastatic.net/s3/yastore-static/resources/images/yakit_ycp_logo_desktop_test.svg?v=2',
        production: 'https://yastatic.net/s3/yastore-static/resources/images/yakit_ycp_logo_desktop_prod.svg?v=2',
        productionPublic: 'https://yastatic.net/s3/yastore-static/resources/images/yakit_ycp_logo_desktop.svg?v=2',
    },
};

export const getCompanyLogoSrc = ({
    env,
    isInternalYandexUser,
    isYCP,
    theme = 'light',
}: {
    env: ENV;
    isInternalYandexUser: boolean;
    isYCP: boolean;
    theme?: ThemeColor;
}) => {
    const logoUrls = (isYCP ? ycpThemeLogoUrls : kitThemeLogoUrls)[theme];

    switch (env) {
        case 'development':
            return logoUrls.development;

        case 'prestable':
            return logoUrls.prestable;

        case 'production':
            return isInternalYandexUser ? logoUrls.production : logoUrls.productionPublic;

        default:
            return logoUrls.productionPublic;
    }
};
